export default "__VITE_ASSET__i7uKzP$1__"